import React from 'react';
import { DefaultReportHeader } from '../components';
import { buildGroupedPrintSections } from './groupPrintSections';

// Grids opt into a print-only column set by marking colDefs with isPrintable.
// Grids that mark none keep printing every displayed column.
const withPrintHeaderName = (colDef) => {
  if (!colDef.printHeaderName) {
    return colDef;
  }
  return { ...colDef, headerName: colDef.printHeaderName };
};

const getPrintColumns = (gridApi) => {
  const displayedColDefs = gridApi.getAllDisplayedColumns().map((col) => col.colDef);
  const printableColDefs = displayedColDefs.filter((colDef) => colDef.isPrintable);
  const columnsToPrint = printableColDefs.length ? printableColDefs : displayedColDefs;
  return columnsToPrint.map(withPrintHeaderName);
};

const getDisplayedRowData =
  ({
    headerProps = null,
    kpiData = null,
    ReportHeader = null,
    groupPrintSections = null,
  } = {}) =>
  (gridApi) => {
    const rowData = [];
    gridApi.forEachNodeAfterFilterAndSort((node) => {
      rowData.push(node.data);
    });
    const columns = getPrintColumns(gridApi);
    const FinalReportHeader = ReportHeader || DefaultReportHeader;

    if (groupPrintSections?.getGroupKey && groupPrintSections?.getSectionHeaderProps) {
      const printSections = buildGroupedPrintSections({
        rowData,
        columns,
        getGroupKey: groupPrintSections.getGroupKey,
        groupOrder: groupPrintSections.groupOrder,
        getSectionHeaderProps: groupPrintSections.getSectionHeaderProps,
        getSectionKpiData: groupPrintSections.getSectionKpiData,
        ReportHeaderComponent: FinalReportHeader,
      });

      return {
        printSections,
        columns,
        pageBreakBetweenSections:
          groupPrintSections.pageBreakBetweenSections ?? true,
      };
    }

    const finalHeaderProps = headerProps || { title: gridApi.gridName ?? 'RouteMax Report' };

    return {
      ReportHeader: <FinalReportHeader {...finalHeaderProps} />,
      rowData,
      columns,
      kpiData: kpiData ?? [`Total: ${rowData.length ?? 0} records`]
    };
  };

export { getDisplayedRowData, getPrintColumns, withPrintHeaderName };
